
import { contentCategoryEnum } from 'pawpaddock-common/data/content'

export default {
  name: 'PrivacyPolicy',

  data() {
    return {
      type: contentCategoryEnum.PRIVACY,
      getContentApi: new this.$ApiModel()
    }
  },

  created() {
    this.getContent()
  },

  methods: {
    async getContent() {
      try {
        await this.$api.content(this.getContentApi).getDoc(this.type)
      } catch (error) {
        this.$log.error('Error getting privacy', error)

        this.$notify.error('Error loading privacy policy, please reload and try again')
      }
    }
  }
}
